'use client';

import Link from 'next/link';
import { FaWhatsapp } from 'react-icons/fa';
import { phoneNumber } from '@/lib/data';

export default function ContattiSection(props) {
  return (
    <section className="min-h-[40vh] flex justify-center md:p-32 p-8 relative bg-[url('/images/rieducazione-posturale.webp')] bg-no-repeat bg-cover bg-center z-20">
      <div className="min-h-full min-w-full absolute top-0 z-30" />
      <div className="z-40 flex flex-col gap-5 items-center justify-center md:px-16 px-8 py-8 bg-secondary-light/50 backdrop-blur-lg rounded-3xl lg:w-[50%] w-[90%] shadow-xl">
        <h3 className="md:text-4xl text-3xl text-primary-900 text-center font-bold tracking-tight">
          {props.title
            ? props.title
            : 'Ritrova il benessere con un percorso riabilitativo'}
        </h3>
        <p className="text-ctext/90 md:text-xl text-lg font-alice leading-text text-center">
          {props.dsc
            ? props.dsc
            : 'Contattami per una valutazione e scopri come posso aiutarti a stare meglio, con trattamenti mirati e un approccio personalizzato.'}
        </p>
        <Link
          className="flex w-fit md:text-xl text-lg font-semibold justify-center text-white text-shadow-2xs text-shadow-black/50 bg-cta-100 hover:bg-cta-100/75 transition-colors duration-300 py-3 px-6 rounded-full shadow-lg flex-row items-center gap-2"
          href={`https://wa.me/39` + phoneNumber}
          target="_blank"
          id="homepage-whatsapp">
          <FaWhatsapp className="text-3xl" />
          {props.cta ? props.cta : 'Scrivimi su Whatsapp'}
        </Link>
      </div>
    </section>
  );
}
